import { render } from "./RowCategory.vue?vue&type=template&id=16f8276c&scoped=true"
import script from "./RowCategory.vue?vue&type=script&lang=js"
export * from "./RowCategory.vue?vue&type=script&lang=js"

import "./RowCategory.vue?vue&type=style&index=0&id=16f8276c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f8276c"]])

export default __exports__